export class Trpconsignment {
    public CN_ID!: number;
    public CN_NO!: string;
    public CN_LOC!: number;
    public CN_TOLOC!: number;
    public CN_REFNO!: string;
    public CN_DATE!: string; //  Date;
    //  Date;
    public CN_TIME!: string;
    public CN_COPY!: boolean;
    public CN_MODE!: string;
    public CN_DELI_INST!: string;
    public CN_FRT_MODE!: string;
    public CN_CRCODE!: string;
    public CN_CNCODE!: string;
    public CN_BOXTYPE!: string;
    public CN_NOB!: number;
    public CN_INVNO!: string;
    public CN_INVVALUE!: number;
    public CN_PARTNO!: string;
    public CN_QTY!: number;
    public CN_H!: number;
    public CN_L!: number;
    public CN_W!: number;
    public CN_CFT!: number;
    public CN_ACTWT!: number;
    public CN_CHGWT!: number;
    public CN_FREIGHT!: number;
    public CN_STCHG!: number;
    public CN_DTDCHG!: number;
    public CN_OTHCHG!: number;
    public CN_COLCHG!: number;
    public CN_MRNO!: string;
    public CN_MRAMT!: number;
    public CN_REMARK!: string;
    public CN_STATUS!: string;
    public CN_UID!: string;
    public CN_FRTONPKG!: boolean;
    public CN_UNITFRT!: number;
    public CN_STPER!: number;
    public CN_ST!: number;
    public CN_DD!: string;
    public CN_INVDATE!: string;
    public CN_ITMDESC!: string;
    public CN_BILLSTATUS!: string;
    public CN_PWF!: string;
    public CN_VT!: string;
    public CN_NETVALUE!: string;
    public CN_BILLPARTY!: string;
    public CN_STPAYBY!: string;
    public CN_PUBLISH!: string;
    public CN_DDRCHARTNO!: string;
    public EnrouteID!: string;
    public CN_ADRNO!: string;
    public CN_ADRDATE!: string;
    public CN_HASPOD!: boolean;
    public CN_SETTAMT!: number;
    public CN_SETTSTATUS!: string;
    public CN_ACTSTS!: string;
    public CN_MRDATE!: string;
    public CN_AGENCY!: string;
    public CN_RUNSTATUS!: string;
    public CN_EWAYBILLNO!: string;
    public POD_STATUS!: string;
    public GPS_STATUS!: string;
    public VEH_NO!: string;
    public MR_STATUS!: string;
    public CN_RFU!: string;
    public MR_REC_DATE!: string;
    public CN_DELUID!: string;
    public PAY_MODE!: string;
    public CHEQUE_NO!: string;
    public CN_UPDATEBY!: string;
    public CN_UPDATEDATE!: string;
    public CN_EWAYEXPIRYDT!: string;
    public CN_ENTRYDATE!: string;
    public CN_SPLVEHCHG!: number;
    public CN_FOVPER!: number;
    public CN_FOV!: number;
    public CN_INSTBY!: string;
    public CN_ADRDT!: string;
    public CN_RUNO!: string;
    public CN_RUDATE!: string;
    public CN_SHORT_QTY!: number;
    public CN_SHORT_REMARK!: string;
    public CN_BANKID!: string;
    public CN_CHARGE1!: string;
    public CN_CHARGE2!: string;
    public CN_UNLOAD_CHARGE!: number;
    public NetTotal!: number;
    public GrandTotal!: number;
    public TDS_AMT!: number;
    public TOLL_CHARGE!: number;
    public DETENTION_CHARGE!: number;
    public CREATEDBY_USERID!: number;
    public UPDATEDBY_USERID!: number;
    public CREATED_DATE!: string; //  Date;
    //  Date;
    public UPDATED_DATE!: string; //  Date;
    //  Date;
    public IS_ACTIVE!: boolean;
    public IS_GRSUBMIT!: boolean;
    public CN_GSTNO!: string;
    public CR_GSTNO!: string;
    public CN_MOBILENO!: string;
    public CR_MOBILENO!: string;
    public BILL_MOBILENO!: string;
    public ISWEB_BOOKING!: boolean;
    public IS_CONFIRM_WEB_BOOKING!: boolean;
}